import { cloneDeep, merge } from 'lodash'

import messages from '@sigma-frontend-libs/messages'

import notifications from './notifications'
import settingsUser from './settingsUser'

const granularCommonLabels = merge(cloneDeep(settingsUser.labels), {
  sendings: {
    phoneNumber: {
      checkMobile: 'Проверить номер мобильного телефона'
    }
  },

  billings: {
    autoAccrual: 'Автопополнение'
  },

  referral: {
    billings: {
      processedChildOperations: 'Обрабатывать финансовые операции реферальной программы дочерних пользователей'
    }
  },

  webhooks: 'Вебхуки',

  notifications: {
    enabled: 'Уведомления включены',

    events: {
      billings: {
        limit: 'Уведомление о пороге баланса [УСТАРЕЛО]'
      },

      tariff: {
        update: 'Уведомление об обновлении тарифа'
      },

      balance: {
        limit: 'Уведомление о пороге баланса',
        accrual: 'Уведомление о начислении на баланс',
        daily: 'Ежедневное уведомление о балансе'
      },

      auth: {
        registration: 'Уведомление о регистрации',
        recover: 'Уведомление о восстановлении пароля'
      },

      pattern: {
        approved: 'Уведомление об одобрении шаблона',
        rejected: 'Уведомление об отклонении шаблона'
      },

      sendername: {
        approved: 'Уведомление об одобрении имени отправителя',
        rejected: 'Уведомление об отклонении имени отправителя'
      },

      sendings: {
        bulk: {
          created: 'Уведомление о создании массовой рассылки',
          paused: 'Уведомление о приостановке массовой рассылки',
          resumed: 'Уведомление о возобновлении массовой рассылки'
        }
      },

      system: {
        platform: {
          issues: 'Уведомление о системной ошибке платформы'
        },

        route: {
          issues: 'Уведомление о системной ошибке маршрутизации'
        }
      }
    },

    email: {
      recipients: 'Получатели уведомлений по email'
    },

    sms: {
      recipients: 'Получатели уведомлений по SMS'
    }
  },

  integrations: {
    pyrus: {
      credentials: 'Данные для подключения к Pyrus'
    }
  },

  reports: {
    maxConcurrentGenerating: 'Максимальное количество одновременно генерируемых отчётов'
  }
})

export default {
  title: 'Права',

  subtitles: {
    presets: 'Пресеты'
  },

  dialogs: {
    titles: {
      info: 'Информация по уровням прав'
    }
  },

  labels: {
    create: 'Создать',
    check: 'Проверить номер',
    finalize: 'Завершать',
    find: 'Найти',
    generate: 'Генерировать',
    set: 'Установить',
    get: 'Получить',
    use: 'Использовать',
    getSendingsForTask: 'Получить отправления для задачи',
    remove: 'Удалить',
    update: 'Обновить',
    modify: 'Изменить',
    seek: 'Seek',
    download: 'Скачать',
    upload: 'Загрузить',
    setRead: 'Установить прочитанным',
    setPermissions: 'Задавать права',
    setRoutingGroups: 'Задавать группы маршрутизаций',
    setMessageRuleGroups: 'Задавать группы правил обработки сообщений',
    setSettings: 'Задавать настройки',
    setSendernames: 'Задавать имена отправителей',
    setPatterns: 'Задавать паттерны',
    setTariffs: 'Задавать тарифы',
    showSecrets: 'Показывать секретные права',
    trigger: 'Триггер',
    health: 'Производительность',
    loginAs: 'Войти под',
    request: 'Запрос',
    controlDocuments: 'Работы с документами',
    edit: 'Редактировать',
    viewChangelogs: 'Просматривать список изменений',
    contracts: 'Договоры',
    companies: 'Компании',
    documentTemplates: 'Шаблоны документов',
    refund: 'Возврат платежа',
    presetUsersBalance: 'Возможность скачивать список пользователей',
    matchKeywords: 'Проверять ключевые слова',
    setOtpChannels: 'Задавать каналы OTP',
    setHasContract: 'Задавать наличие договора',

    ...messages.ru['report-manager'].types,

    ...settingsUser.paths,

    notifications: {
      enabled: 'Уведомления включены',

      events: notifications.events,
      childrenUsersEvents: notifications.childrenUsersEvents,

      email: {
        recipients: 'Получатели уведомлений по email'
      },

      sms: {
        recipients: 'Получатели уведомлений по SMS'
      }
    },

    me: {
      settingsUser: granularCommonLabels
    },

    child: {
      settingsUser: granularCommonLabels
    }
  },

  hints: {
    warning: 'Изменение прав не требует обновления пользователя.'
  },

  tooltips: {
    info: 'Информация по уровням прав'
  },

  buttons: {
    false: 'False',
    me: 'User',
    reseller: 'Reseller'
  },

  origins: {
    me: 'Собственные',
    child: 'Дочерние'
  },

  services: {
    ...messages.ru.services,

    referral: 'Реферальная программа',
    integrations: 'Интеграции',
    webhooks: 'Веб-хуки',
    websocket: 'WebSocket',
    smpp: 'SMPP',
    granular: 'Гранулярные',
    secret: 'Секретные',

    child: {
      settingsUser: 'Дочерние настройки пользователя'
    },

    me: {
      settingsUser: 'Собственные настройки пользователя'
    }
  },

  accepts: {
    false: 'Запрещает любые действия требующие соответствующее право.',
    me: 'Разрешает действия с объектами, которые пользователь создал сам, или ему создал его реселлер или администратор.',
    manager: 'Разрешает действия с объектами, которые принадлежат самому пользователю, либо привязанным к менеджеру пользователям.',
    reseller: 'Разрешает действия с объектами, которые принадлежат самому пользователю, либо дочерним пользователям реселлера.',
    true: 'Разрешает действия с любыми объектами в системе.',
    default: 'Право по умолчанию.',
    read: 'Разрешает только чтение значения, но не позволяет его изменять.',
    write: 'Разрешает чтение и изменение значения.'
  },

  snackbars: {
    updated: 'Право успешно обновлено'
  },

  tooltips: {
    accepts: {
      default: 'Право на просмотр или редактирование данной настройки не изменялось.',
      read: 'Вам разрешено только просматривать значение.',
      write: 'Вам разрешено просматривать и изменять значение.'
    },

    origins: {
      me: 'Права управляют доступом к просмотру и редактированию своих настроек пользователя (поверх базовой схемы).',
      child: 'Права управляют доступом к просмотру и редактированию настроек дочерних пользователей (поверх базовой схемы).'
    }
  },

  tabs: {
    advanced: 'Расширенные',
    granular: 'Гранулярные',
    secret: 'Секретные'
  }
}
